<div class="container h-100 d-flex flex-column">
    <div class="row">
        <div class="col-12 p-3">
            <span runat="server" cvLocalizedText langSection="Command_Center" langKey="Onboarding_Message">
                Let's begin by setting things up. What would you like to see in your center? P.S. You can always go to settings later and adjust what is visible.
            </span>
        </div>
    </div>

    <div class="row flex-fill">
        <div class="col-12" *ngFor="let tab of gms.availableTabs">
            <div class="form-group row" *ngIf="tab.name !== 'Overview'">
                <div class="form-check offset-1 col-1">
                    <input class="form-check-input" id="chkArea-{{tab.name}}" type="checkbox" [ngModel]="isAreaShown(tab.name)" (change)="areaSelection(tab.name, $event)">
                </div>
                <label class="form-check-label col-9" for="chkArea-{{tab.name}}">
                    <div class="font-weight-bold">{{tab.localizedName}}</div>
                    <div>{{gms.areaDescriptions[tab.name]}}</div>
                </label>
            </div>
        </div>
    </div>

    <hr />
    
    <div class="row">
        <div class="col-12 p-3">
            <div class="font-weight-bold" cvLocalizedText langSection="Command_Center" langKey="Global_Settings">Global Settings</div>
            <p cvLocalizedText langSection="Command_Center" langKey="Global_Settings_Desc">This settings will apply to all users under the Gamification Package.</p>
            
            <div class="form-group row">
                <div class="form-check offset-1 col-1">
                    <input class="form-check-input" id="chkArea-collect" type="checkbox" [(ngModel)]="collectButton">
                </div>
                <label class="form-check-label col-9" for="chkArea-collect">
                    <div class="font-weight-bold" cvLocalizedText langSection="Command_Center" langKey="Collect_Button">Collect Button</div>
                    <div cvLocalizedText langSection="Command_Center" langKey="Collect_Button_Desc">Require users to manually collect rewards from games widget.</div>
                </label>
            </div>

            <div class="form-group row offset-2">
                <div class="col-12 pl-1 body-2 color-whaleTail" cvLocalizedText langSection="Command_Center" langKey="Uncollected_Coins_Expire">Uncollected Coins Expire</div>
                <select class="form-control w-100 col-7 ml-1" id="ob-interval" name="ob-interval" [(ngModel)]="selectedInterval" [disabled]="!collectButton">
                    <option *ngFor="let interval of intervals" [ngValue]="interval">{{ interval.name }}</option>
                </select>
            </div>
            <div [ngClass]="{
              'form-group': true,
              'wrapper-expandable': true,
              'expanded': !collectButton && gms.globalSettings.CollectButton
            }">
                <div class="row offset-1 expandable">
                  <div class="warning-message">
                    <svg class="icon-32" style="fill: #E4B321;"><use href="../App_Themes/clearview-default/icons/utility/notice-16px.svg#notice"></use></svg>
                    <div class="warning-body">
                      <h2 class="warning-title" cvLocalizedText langSection="Command_Center" langKey="Disabling_collect_button_title">Notice</h2>
                      <p class="warning-content" cvLocalizedText langSection="Command_Center" langKey="Disabling_collect_button">Disabling the collect button will automatically distribute all outstanding rewards.</p>
                    </div>
                  </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row p-3">
        <cv-loader [size]="'medium'" [overlay]="false" *ngIf="isLoading"></cv-loader>
        <button id="gamificationSaveBtn" class="btn btn-primary clickable ml-auto" [disabled]="isLoading" cvLocalizedText langSection="Common" langKey="Save_Button" (click)="save()">Save</button>
    </div>
</div>
